/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_Q4Inputs */

const en_pc_dl_faq_q4 = /** @type {(inputs: Pc_Dl_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there one Mac download for Apple silicon and Intel?`)
};

const zh_pc_dl_faq_q4 = /** @type {(inputs: Pc_Dl_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple 芯片和 Intel Mac 用同一个安装包吗？`)
};

/**
* | output |
* | --- |
* | "Is there one Mac download for Apple silicon and Intel?" |
*
* @param {Pc_Dl_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_q4 = /** @type {((inputs?: Pc_Dl_Faq_Q4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_Q4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_q4(inputs)
	return zh_pc_dl_faq_q4(inputs)
});
export { pc_dl_faq_q4 as "pc.dl.faq.q4" }